module.exports = __webpack_public_path__ + "static/img/home page banner 1.98507f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home page banner 1.png
// module id = oon2
// module chunks = 1